<div class="vault-page-shell">
  <div class="mx-auto max-w-2xl">
    <section class="vault-panel px-6 py-8 text-center sm:px-10 sm:py-12">
      <div class="space-y-6">
        <div class="flex justify-center items-center">
          <h1 class="az-logo">fasten</h1>
        </div>

        <div class="space-y-3">
          <p class="vault-page-kicker">Verification error</p>
          <h2 class="text-3xl font-semibold tracking-tight text-red-600">Something went wrong</h2>
          <p id="error-message" class="mx-auto max-w-lg text-sm leading-7 text-slate-500">We hit an error while verifying your identity. Review the details below and try again when you’re ready.</p>
        </div>

        <div id="error-details" class="rounded-lg bg-slate-100 p-5 text-left">
          <h3 class="text-sm font-semibold uppercase tracking-[0.16em] text-slate-500">Error details</h3>
          <p class="mt-3 text-sm text-slate-800">Error Type: <span class="font-semibold">{{error}}</span></p>
          <p class="mt-2 text-sm text-slate-800">Description: <span>{{error_description}}</span></p>
        </div>

        <div class="flex justify-center">
          <button [routerLink]="'/auth/identity/verification'" type="button" class="vault-primary-button">
            Try Again
          </button>
        </div>
      </div>
    </section>
  </div>
</div>
